'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _spauiUtils = require('@tencent/spaui-utils');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../utils/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var NavBarCollapse = function (_PureComponent) {
    _inherits(NavBarCollapse, _PureComponent);

    function NavBarCollapse() {
        _classCallCheck(this, NavBarCollapse);

        return _possibleConstructorReturn(this, (NavBarCollapse.__proto__ || Object.getPrototypeOf(NavBarCollapse)).apply(this, arguments));
    }

    _createClass(NavBarCollapse, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$list = _props.list,
                propsList = _props$list === undefined ? [] : _props$list,
                searchValue = _props.searchValue,
                onSearchChange = _props.onSearchChange,
                open = _props.open,
                LinkComponent = _props.LinkComponent,
                propsValue = _props.value;

            var className = (0, _classnames2.default)('spaui-topnav-collapse', {
                'is-collapse': !open
            }),
                list = [],
                haveLeft = false,
                haveRight = false;

            if (propsList.length < 2 && propsList.length > 0) {
                propsList.map(function (item) {
                    if (item.placement === 'left') {
                        haveLeft = true;
                        list.push(item);
                    } else if (item.placement === 'right') {
                        haveRight = true;
                        list.push(item);
                    }
                    return item;
                });

                if (haveRight && !haveLeft) {
                    list.unshift({
                        placement: 'left'
                    });
                }
            } else {
                list = propsList;
            }

            return _react2.default.createElement(
                'div',
                (0, _spauiUtils.globalProps)(this.props, {
                    className: className,
                    needTitle: false
                }),
                list.map(function () {
                    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var index = arguments[1];
                    var _item$placement = item.placement,
                        placement = _item$placement === undefined ? '' : _item$placement,
                        _item$value = item.value,
                        value = _item$value === undefined ? '' : _item$value,
                        _item$data = item.data,
                        data = _item$data === undefined ? [] : _item$data;


                    return _react2.default.createElement(
                        'ul',
                        {
                            className: (0, _classnames2.default)('navs spaui-topnav-nav', item.className || '', {
                                'spaui-topnav-right': placement === 'right'
                            }),
                            key: index
                        },
                        data.map(function () {
                            var dataItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            var dataIndex = arguments[1];
                            var _dataItem$data = dataItem.data,
                                subData = _dataItem$data === undefined ? [] : _dataItem$data,
                                _dataItem$type = dataItem.type,
                                type = _dataItem$type === undefined ? '' : _dataItem$type,
                                _dataItem$url = dataItem.url,
                                url = _dataItem$url === undefined ? '' : _dataItem$url,
                                _dataItem$key = dataItem.key,
                                key = _dataItem$key === undefined ? '' : _dataItem$key,
                                _dataItem$label = dataItem.label,
                                label = _dataItem$label === undefined ? '' : _dataItem$label,
                                _dataItem$disabled = dataItem.disabled,
                                disabled = _dataItem$disabled === undefined ? false : _dataItem$disabled,
                                _dataItem$className = dataItem.className,
                                dataItemClassName = _dataItem$className === undefined ? '' : _dataItem$className;

                            var result = null,
                                subDataList = [],
                                liClassName = (0, _classnames2.default)('nav-item', dataItemClassName),
                                itemClassName = 'nav-link',
                                TheComponent = null;

                            if (type === 'component' && dataItem.component) {
                                TheComponent = dataItem.component;
                                return _react2.default.createElement(TheComponent, _extends({}, dataItem, {
                                    key: dataItem.type + dataIndex,
                                    component: '',
                                    className: liClassName,
                                    value: value,
                                    rootValue: propsValue
                                }));
                            } else if (key && type !== 'search' && type !== 'userinfo') {
                                liClassName = (0, _classnames2.default)(liClassName, {
                                    active: key === value || key === propsValue,
                                    disabled: disabled,
                                    'spaui-topnav-drop': subData.length > 0
                                });

                                if (subData.length > 0) {
                                    itemClassName += ' spaui-topnav-toggle';

                                    subData.map(function (subDataItem) {
                                        subDataList.push(subDataItem.key);
                                        return subDataItem;
                                    });

                                    if ((0, _spauiUtils.indexOf)(subDataList, value) > -1 || (0, _spauiUtils.indexOf)(subDataList, propsValue) > -1) {
                                        liClassName += ' active';
                                    }

                                    result = _react2.default.createElement(
                                        'li',
                                        {
                                            role: 'presentation',
                                            className: liClassName,
                                            key: dataIndex
                                        },
                                        _react2.default.createElement(
                                            LinkComponent,
                                            _extends({
                                                name: key,
                                                role: 'button',
                                                className: itemClassName,
                                                href: url || 'javascript:;',
                                                'data-toggle': 'dropdown',
                                                'aria-haspopup': 'true',
                                                'aria-expanded': 'false'
                                            }, (0, _index.getSupportEventMap)(dataItem)),
                                            label
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'spaui-topnav-menu', 'aria-labelledby': 'spaui-topnavDropdown' },
                                            subData.map(function (subDataItem, subDataIndex) {
                                                var subItemClassName = (0, _classnames2.default)('spaui-topnav-menu-item', subDataItem.className || '');
                                                if (subDataItem.type === 'divider') {
                                                    return _react2.default.createElement('div', {
                                                        key: subDataIndex,
                                                        className: 'spaui-topnav-menu-divider'
                                                    });
                                                }
                                                return _react2.default.createElement(
                                                    LinkComponent,
                                                    _extends({
                                                        name: subDataItem.key,
                                                        key: subDataIndex,
                                                        className: subItemClassName,
                                                        href: subDataItem.url || 'javascript:;'
                                                    }, (0, _index.getSupportEventMap)(subDataItem)),
                                                    subDataItem.label || ''
                                                );
                                            })
                                        )
                                    );
                                } else {
                                    result = _react2.default.createElement(
                                        'li',
                                        { role: 'presentation', className: liClassName, key: dataIndex },
                                        _react2.default.createElement(
                                            LinkComponent,
                                            _extends({
                                                name: key,
                                                role: 'button',
                                                className: itemClassName,
                                                href: url || 'javascript:;'
                                            }, (0, _index.getSupportEventMap)(dataItem)),
                                            label
                                        )
                                    );
                                }
                                return result;
                            } else {
                                if (type === 'search') {
                                    var _searchValue = typeof searchValue !== 'undefined' ? searchValue : dataItem.value || '';
                                    var _onChange = typeof onSearchChange !== 'undefined' ? onSearchChange : dataItem.onChange || function () {};

                                    result = _react2.default.createElement(
                                        'li',
                                        { role: 'presentation', className: 'nav-item', key: dataIndex },
                                        _react2.default.createElement(
                                            'form',
                                            { className: 'form-inline spaui-topnav-form spaui-topnav-right' },
                                            _react2.default.createElement('input', _extends({
                                                className: 'form-control',
                                                type: 'text',
                                                value: _searchValue,
                                                placeholder: dataItem.placeholder,
                                                onChange: _onChange
                                            }, (0, _index.getSupportEventMap)(dataItem)))
                                        )
                                    );
                                } else if (type === 'userinfo') {
                                    result = _react2.default.createElement(
                                        'li',
                                        { role: 'presentation', className: 'nav-item', key: dataIndex },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'userinfo' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'user btn-group spaui-topnav-drop' },
                                                dataItem.txUrl || dataItem.nickname || subData.length > 0 ? _react2.default.createElement(
                                                    'button',
                                                    _extends({
                                                        type: 'button',
                                                        className: 'btn btn-link btn-sm spaui-topnav-toggle',
                                                        'data-toggle': 'dropdown',
                                                        'aria-haspopup': 'true',
                                                        'aria-expanded': 'false'
                                                    }, (0, _index.getSupportEventMap)(dataItem)),
                                                    dataItem.txUrl ? _react2.default.createElement('img', {
                                                        className: 'user-avatar',
                                                        src: dataItem.txUrl || '',
                                                        width: '30',
                                                        height: '30'
                                                    }) : null,
                                                    _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        dataItem.nickname ? _react2.default.createElement(
                                                            'span',
                                                            { className: 'menu-text' },
                                                            dataItem.nickname || ''
                                                        ) : null,
                                                        subData.length > 0 ? _react2.default.createElement('i', { className: 'icon-darr', 'aria-hidden': 'true' }) : null
                                                    )
                                                ) : null,
                                                subData.length > 0 ? _react2.default.createElement(
                                                    'div',
                                                    { className: 'spaui-topnav-menu' },
                                                    subData.map(function (subDataItem, subDataIndex) {
                                                        if (!subDataItem.label) {
                                                            return null;
                                                        }

                                                        return _react2.default.createElement(
                                                            LinkComponent,
                                                            _extends({
                                                                name: subDataItem.key,
                                                                className: 'spaui-topnav-menu-item',
                                                                href: subDataItem.url || 'javascript:;',
                                                                key: subDataIndex
                                                            }, (0, _index.getSupportEventMap)(subDataItem)),
                                                            subDataItem.label || ''
                                                        );
                                                    })
                                                ) : null
                                            )
                                        )
                                    );
                                }

                                return result;
                            }
                        })
                    );
                })
            );
        }
    }]);

    return NavBarCollapse;
}(_react.PureComponent);

exports.default = NavBarCollapse;